import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const Accordion = ({ sections }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-6">
      {sections.map((section, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200 bg-white"
        >
          <button
            className="w-full px-8 py-6 text-left bg-white hover:bg-gray-50 transition-all duration-200 flex items-center justify-between group"
            onClick={() => toggleAccordion(index)}
            aria-expanded={openIndex === index}
            aria-controls={`accordion-content-${index}`}
          >
            <h3 className="text-lg font-semibold text-gray-900 pr-4 group-hover:text-primary-600 transition-colors duration-200">
              {section.title}
            </h3>
            {openIndex === index ? (
              <ChevronUp className="h-6 w-6 text-primary-600 flex-shrink-0 transition-transform duration-200" />
            ) : (
              <ChevronDown className="h-6 w-6 text-gray-500 group-hover:text-primary-600 flex-shrink-0 transition-all duration-200" />
            )}
          </button>

          <div
            id={`accordion-content-${index}`}
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              openIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <div className="px-8 pb-8 text-gray-700 leading-relaxed space-y-6">
              <div className="prose prose-lg max-w-none">{section.content}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
